module.exports = {"Getting started":{"Quick start":"quick-start"},"Command reference":{"Running a script":"cmd-run","Generating files":"cmd-generate","Validating files":"cmd-validate","Transforming files":"cmd-transform","Common options":"cmd-options","Module resolution":"module-resolution"},"Standard library":{"Printing and logging":"std-log","Writing files":"std-write","Reading files":"std-read","Module resources":"std-resource","Input parameters":"std-param","Filesystem":"std-fs","Parsing and stringifying":"std-parse","API reference":"std-api-reference"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/navigation.json
// module id = rr5i
// module chunks = 1